import React, { Component } from 'react';
import classnames from 'classnames';
import { includes, isEqual, without } from 'lodash';
import request from 'superagent';
import { defaultSettings } from '../store/settings';

class Settings extends Component {
  state = {
    chargeSettings: this.props.settings.chargeSettings,
    gopayUnbindSettings: this.props.settings.gopayUnbindSettings,
    showSettingsDetails: false,
    feature: this.props.settings.feature,
    save: false
  }

  onCancel = () => {
    this.state.gopayUnbindSettings = defaultSettings.gopayUnbindSettings
    this.props.onCancel()
  }

  changeSettings = (name, value) => {
    const chargeSettings = this.state.chargeSettings
    chargeSettings[name] = value
    this.setState({chargeSettings})
  }

  setGopayUnbindSettings = (fieldName, value) => {
    this.setState(prevState => ({
      gopayUnbindSettings: {
        ...prevState.gopayUnbindSettings,
        [fieldName]: value
      }
    }));
  };

  changeMemberSettings = (name, value, checked) => {
    const chargeSettings = this.state.chargeSettings
    let current = chargeSettings[name] || []
    if (checked && !includes(current, value)) {
      current.push(value)
    } else if (!checked) {
      current = without(current, value)
    }
    chargeSettings[name] = current
    this.setState({chargeSettings})
  }

  /**
   * TODO(opt): Optimise if condition
   * @date - 21-08-2017
   * @time - 16:04
   */
  paymentChannelIsEnabled = (paymentChannel) => {
    if (this.state.chargeSettings) {
      if (!this.state.chargeSettings.enabled_payments_use) {
        return true
      }
      if (this.state.chargeSettings.enabled_payments) {
        return this.state.chargeSettings.enabled_payments.includes(paymentChannel)
      }
      return false
    }
    return true
  }

  isBankEnabled = (bank) => {
     return this.paymentChannelIsEnabled('bank_transfer') &&
       (!this.state.chargeSettings.use_custom_bank_list ||
       this.state.chargeSettings.bank_enabled_payments && this.state.chargeSettings.bank_enabled_payments.includes(bank))
  }

  onSaveSettings = (event) => {
    this.setState({save: event.target.checked})
  }

  onStart = () => {
    this.onCancel()
    this.props.onStart({chargeSettings: this.state.chargeSettings, feature: this.state.feature}, this.state.save)
  }

  onUnbind = () => {
    if (this.state.gopayUnbindSettings.loading || !this.state.gopayUnbindSettings.gopay_phone_number) return;

    this.setGopayUnbindSettings('loading', true);

    let baseUrl = document.querySelector('head base').getAttribute('href');
    let unbindUrl = baseUrl + ((baseUrl !== '/') ? '/' : '') + 'unbind';
    let csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

    request
      .post(unbindUrl)
      .send({
        _csrf: csrfToken,
        gopay_phone_number: this.state.gopayUnbindSettings.gopay_phone_number,
        settings: {
          use_merchant_keys: this.state.chargeSettings.use_merchant_keys,
          server_key: this.state.chargeSettings.server_key
        }
      })
      .end((err, res) => {
        const isSuccess = !err && res && res.statusCode === 200;
        const isInvalidPhoneNumber = res && res.statusCode === 400;

        this.setGopayUnbindSettings('unbindSuccess', isSuccess);

        if (isSuccess) {
          this.setGopayUnbindSettings('unbindMessages', 'Unbind successful!');
        } else if (isInvalidPhoneNumber) {
          this.setGopayUnbindSettings('unbindMessages', 'Phone number is not supported.');
        } else {
          this.setGopayUnbindSettings('unbindMessages', 'Please try again later.');
        }

        this.setGopayUnbindSettings('loading', false);
      });

  };

  radio = (name, value, label, onChange, isChecked, activeShading) => {
    const id = [name, value].join(':')
    if (onChange === undefined) {
      onChange = () => {
        this.changeSettings(name, value)
      }
    }

    if (isChecked === undefined) {
      isChecked = isEqual(this.state.chargeSettings[name], value)
    }
    return (
      <div className="radio-group inline-block">
        <input type="radio" name={name} id={id} onChange={onChange} value={value} checked={isChecked}></input>
        <label htmlFor={id} dangerouslySetInnerHTML={{__html: label}}></label>
      </div>
    )
  }

  checkbox = (name, value, label, onChange, isChecked) => {
    if (onChange === undefined) {
      onChange = (event) => {
        this.changeMemberSettings(name, value, event.target.checked)
      }
    }

    if (isChecked === undefined) {
      isChecked = includes(this.state.chargeSettings[name], value)
    }
    const id = [name, value].join(':')
    return (
      <div className="checkbox-group inline-block">
        <input type="checkbox" id={id} onChange={onChange} checked={isChecked}></input>
        <label htmlFor={id} dangerouslySetInnerHTML={{__html: label}}></label>
      </div>
    )
  }

  toggleRadio = (name, enable) => {
    if (!enable) {
      this.changeSettings(name, null)
    }
    this.setState({[name]: enable})
  }

  radioTextBox = (name, placeholder, helperText) => {
    return (
      <div className="col-sm-12">
        <div className="radio-group inline-block">
          <input type="radio" name={name} id={name + '_disabled'} onChange={() => this.toggleRadio(name, false)}
                 checked={!this.state[name]}></input>
          <label htmlFor={name + '_disabled'}>Disabled</label>
        </div>
        <div className={classnames('radio-group inline-block with-subsection', {active: this.state[name]})}>
          <input type="radio" name={name} id={name + '_enabled'} onChange={() => this.toggleRadio(name, true)}
                 checked={this.state[name]}></input>
          <label htmlFor={name + '_enabled'}>Enabled</label>
        </div>
        <div className={classnames('subsection', {active: this.state[name]})}>
          <div>
            <input type="text" onChange={(event) => {
              this.changeSettings(name, event.target.value)
            }} value={this.state.chargeSettings[name]} placeholder={placeholder}/>
            <span className="helper">{helperText}</span>
          </div>
        </div>
      </div>
    )
  }

  gopayTokenizationPayment = () => {
    const { gopayUnbindSettings } = this.state;
    const buttonContent = gopayUnbindSettings.loading ? (
      <img alt="loading..." src="/images/load.gif"/>
    ) : 'Unbind';

    return !this.paymentChannelIsEnabled('gopay') ? null : (
      <div>
        <div className="section">Gopay Tokenization Settings</div>
        <div className="row">
          <div className="col-sm-12">
            <label className="section-label">User ID</label>
          </div>
          {this.radioTextBox('gopay_user_id', 'User ID', 'The id of user that will be bind to the GoPay account')}
        </div>
        <div className="row">
          <div className="col-sm-12">
            <label className="section-label">Unbind GoPay Phone Number</label>
          </div>
          <div className="col-sm-12">
            <div className={classnames('subsection active bg-transparent')}>
              <input type="number" onChange={(event) => {
                this.setGopayUnbindSettings('gopay_phone_number', event.target.value);
              }} value={gopayUnbindSettings.gopay_phone_number} placeholder='Enter 62....'/>
              <a href="#" className="btn-primary" onClick={this.onUnbind}>{buttonContent}</a>
              {gopayUnbindSettings.unbindMessages && (
                <span
                  className={classnames("status-message", {
                    success: gopayUnbindSettings.unbindSuccess,
                    error: !gopayUnbindSettings.unbindSuccess
                  })}
                >
                  {gopayUnbindSettings.unbindMessages}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }

  creditCardPayment = () => {
    return !this.paymentChannelIsEnabled('credit_card') ? null : (
      <div>
        <div className="section">Credit Card Settings</div>
        <div className="row">
          <div className="col-sm-12">
            <label className="section-label">Recurring User</label>
          </div>
          <div className="col-sm-12">
            {this.radio('user_id', 'normal', 'Normal')}
            {this.radio('user_id', 'demo_one_click', '1-Clicks')}
            {this.radio('user_id', 'demo_two_clicks', '2-Clicks <br /><span class="helper">(CVV: 123)</span>')}
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <label className="section-label">3DS Authentication</label>
          </div>
          <div className="col-sm-12">
            {this.radio('authentication', '3ds', 'Enabled')}
            {this.radio('authentication', 'none', 'Disabled')}
            {/* {this.radio('authentication', 'rba', 'RBA')} */}
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <label className="section-label">Acquiring Bank</label>
          </div>
          <div className="col-sm-12">
            {this.radio('credit_card_bank', null, 'Default')}
            {this.radio('credit_card_bank', 'bni', 'BNI')}
            {this.radio('credit_card_bank', 'bca', 'BCA')}
            {this.radio('credit_card_bank', 'cimb', 'CIMB Niaga')}
            {this.radio('credit_card_bank', 'bri', 'BRI')}
            {this.radio('credit_card_bank', 'mandiri', 'Mandiri')}
            {this.radio('credit_card_bank', 'maybank', 'Maybank')}
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12">
            <label className="section-label"><span>Pre-Auth<div className="info-tooltip"><div
              className="content">When pre-auth is enabled, customers` balance will be held up to 7 days or until the transaction is captured by the Merchant. If the transaction is cancelled within the pre-auth period is active, refunds will be done without any waiting period.</div></div></span></label>
          </div>
          <div className="col-sm-12">
            {this.radio('credit_card_type', 'authorize_capture', 'Disabled')}
            {this.radio('credit_card_type', 'authorize', 'Enabled')}
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <label className="section-label">Mandiri Points Only</label>
          </div>
          <div className="col-sm-12">
            {this.radio('credit_card_mandiri_whitelist_bins', null, 'Disabled')}
            {this.radio('credit_card_mandiri_whitelist_bins', ['mandiri'], 'Enabled', () => {
              this.changeSettings('credit_card_mandiri_whitelist_bins', ['mandiri'])
              this.changeSettings('credit_card_bni_whitelist_bins', null)
            })}
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <label className="section-label">BNI Points Only</label>
          </div>
          <div className="col-sm-12">
            {this.radio('credit_card_bni_whitelist_bins', null, 'Disabled')}
            {this.radio('credit_card_bni_whitelist_bins', ['bni'], 'Enabled', () => {
              this.changeSettings('credit_card_bni_whitelist_bins', ['bni'])
              this.changeSettings('credit_card_mandiri_whitelist_bins', null)
            })}
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <label className="section-label">Installment</label>
          </div>
          <div className="col-sm-12">
            <div className={classnames('radio-group inline-block with-subsection')}>
              <input type="radio" name="installment_use" id="installment_use:disabled" onChange={() => {
                this.changeSettings('installment_use', 'disabled')
              }} value="disabled"
                     checked={isEqual(this.state.chargeSettings['installment_use'], 'disabled')}></input>
              <label htmlFor={'installment_use:disabled'}
                     dangerouslySetInnerHTML={{__html: 'Disabled'}}></label>
            </div>
            <div
              className={classnames('radio-group inline-block with-subsection', {active: this.state.chargeSettings.installment_use === 'required'})}>
              <input type="radio" name="installment_use" id="installment_use:required" onChange={() => {
                this.changeSettings('installment_use', 'required')
              }} value="required"
                     checked={isEqual(this.state.chargeSettings['installment_use'], 'required')}></input>
              <label htmlFor={'installment_use:required'}
                     dangerouslySetInnerHTML={{__html: 'Required'}}></label>
            </div>
            <div
              className={classnames('radio-group inline-block with-subsection', {active: this.state.chargeSettings.installment_use === 'optional'})}>
              <input type="radio" name="installment_use" id="installment_use:optional" onChange={() => {
                this.changeSettings('installment_use', 'optional')
              }} value="optional"
                     checked={isEqual(this.state.chargeSettings['installment_use'], 'optional')}></input>
              <label htmlFor={'installment_use:optional'}
                     dangerouslySetInnerHTML={{__html: 'Optional'}}></label>
            </div>
          </div>
          <div
            className={classnames('col-sm-12 subsection', {active: this.state.chargeSettings.installment_use === 'required' || this.state.chargeSettings.installment_use === 'optional'})}>
            {this.checkbox('installment_terms', 'bni', 'BNI')}
            {this.checkbox('installment_terms', 'bca', 'BCA')}
            {this.checkbox('installment_terms', 'mandiri', 'Mandiri')}
            {this.checkbox('installment_terms', 'cimb', 'CIMB')}
            {this.checkbox('installment_terms', 'bri', 'BRI')}
            {this.checkbox('installment_terms', 'maybank', 'Maybank')}
            {this.checkbox('installment_terms', 'offline', 'Offline')}
          </div>
        </div>
      </div>
    )
  }

  bankList = () => {
    return !this.state.chargeSettings.enabled_payments_use ? null : (
      <div>
        {this.radio('use_custom_bank_list', false, 'All', () => {
          this.changeSettings('use_custom_bank_list', false)
        })}
        <div
          className={classnames('radio-group inline-block with-subsection', {active: this.state.chargeSettings['use_custom_bank_list']})}>
          <input type="radio"
                 name={name} id="custom_bank_select"
                 onChange={() => {
                   this.changeSettings('use_custom_bank_list', true)
                 }}
                 value="optional"
                 checked={this.state.chargeSettings['use_custom_bank_list']}/>
          <label htmlFor="custom_bank_select">Custom Bank Select</label>
        </div>
        <div className={classnames('subsection', {active: this.state.chargeSettings.use_custom_bank_list})}>
          {this.checkbox('bank_enabled_payments', 'bca_va', 'BCA')}
          {this.checkbox('bank_enabled_payments', 'echannel', 'Mandiri')}
          {this.checkbox('bank_enabled_payments', 'bni_va', 'BNI')}
          {this.checkbox('bank_enabled_payments', 'bri_va', 'BRI')}
          {this.checkbox('bank_enabled_payments', 'permata_va', 'Permata')}
          {this.checkbox('bank_enabled_payments', 'danamon_va', 'Danamon')}
          {this.checkbox('bank_enabled_payments', 'cimb_va', 'CIMB')}
          {this.checkbox('bank_enabled_payments', 'other_va', 'Other Bank')}
        </div>
      </div>
    )
  }

  customVaNumberRow = (bankKey, inputName, label, description) =>  {
    return (
      <div className={classnames('row', { inactive: !this.isBankEnabled(bankKey) })}>
        <div className="col-sm-12">
          <label className="section-label">{label}</label>
        </div>
        {this.radioTextBox(inputName, label, description)}
      </div>
    );
  }

  atmTransferPayment = () => {
    return !this.paymentChannelIsEnabled('bank_transfer') ? null : (
      <div>
        <div className="section">Virtual Account / Bank Transfer Settings</div>
        {this.bankList()}
        {this.customVaNumberRow('permata_va', 'permata_va_number', 'Custom Permata VA', 'Numbers only. Length should be 10.')}
        {this.customVaNumberRow('bca_va', 'bca_va_number', 'Custom BCA VA', 'Numbers only. Length should be within 1 to 11.')}
        {this.customVaNumberRow('bni_va', 'bni_va_number', 'Custom BNI VA', 'Numbers only. Length should be within 1 to 8.')}
        {this.customVaNumberRow('bri_va', 'bri_va_number', 'Custom BRI VA', 'Numbers only. Length should be within 1 to 13.')}
        {this.customVaNumberRow('cimb_va', 'cimb_va_number', 'Custom CIMB VA', 'Numbers only. Length should be within 1 to 16.')}
        {this.customVaNumberRow('danamon_va', 'danamon_va_number', 'Custom Danamon VA', 'Numbers only. Length should be within 1 to 12.')}
        <div className="row">
          <div className="col-sm-12">
            <label className="section-label">Custom Expiry</label>
          </div>
          <div className="col-sm-12">
            {this.radio('expiry', 'default', 'Default')}
            {this.radio('expiry', '1-min', '1 minute')}
            {this.radio('expiry', '5-min', '5 minutes')}
          </div>
        </div>
      </div>
    )
  }

  onFeatureChange = () => {
    if (this.state.feature === 'default') {
      this.setState({feature: 'custom'});
      const element = document.getElementById("main_setting_div_custom");
      setTimeout(() => {
        element.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
      }, 0);
    } else {
      this.setState({feature: 'default'});
    }
  }

  render () {
    return (
      <div className={classnames('settings-modal', {hide: !this.props.show})}>
        <div className="modal-header">
          SNAP Features Settings
          <div className="modal-close" onClick={this.onCancel}>
            &times;
          </div>
        </div>
        <div className="modal-content">
          <div className="row">
            <div className="col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1 hide-sm text-center">
              <img src="images/settings.png" alt="Features Settings" width="100%"/>
            </div>
            <div className="col-md-8 col-md-offset-2 col-sm-12 col-sm-offset-0">
              <h3 className="text-center">Welcome to Snap Demo!</h3>
              <p className="small text-center">This demo will showcase the various features of Snap.</p>
              <br/>
            </div>
            <br/>
            <div className="radio-group inline-block main-setting-radio">
              <input type="radio" name="main-setting" id="main_setting_default" value="default" onChange={this.onFeatureChange} checked={this.state.feature === 'default'}></input>
              <label htmlFor="main_setting_default">
                Start with the most common features enabled <span className="details pull-right" onClick={() => {
                this.setState({showSettingsDetails: !this.state.showSettingsDetails})
              }}>Details &darr;</span>
                <div className={classnames('setting-details', {active: this.state.showSettingsDetails})}>
                  <p>The following settings will be applied:</p>
                  <ol>
                    <li>All bank network for Virtual Account / Bank Transfer will be activated</li>
                    <li>Theme: Navyblue</li>
                    <li>
                      Credit Card:
                      <ul>
                        <li>Recurring User disabled</li>
                        <li>3D-Secure authentication active</li>
                        <li>Default Acquiring Bank (randomized)</li>
                        <li>Pre-Auth disabled</li>
                        <li>BNI Points redeem disabled</li>
                        <li>Installment disabled</li>
                      </ul>
                    </li>
                    <li>
                      Virtual Account / Bank Transfer:
                      <ul>
                        <li>Custom VA Numbers disabled</li>
                      </ul>
                    </li>
                    <li>Default payment expiration time (24 hours)</li>
                  </ol>
                </div>
              </label>
            </div>
            <br/>
            <div className="radio-group inline-block main-setting-radio" id="main_setting_div_custom">
              <input type="radio" name="main-setting" id="main_setting_custom" value="custom" onChange={this.onFeatureChange} checked={this.state.feature === 'custom'}></input>
              <div className="label main_setting_custom">
                <label htmlFor="main_setting_custom">Set advanced rules</label>
                <div className={classnames('setting-details', {active: this.state.feature === 'custom'})}>
                  <div className="alert warning">The settings below are for demo only. It <strong>WILL NOT</strong> be
                    reflected to your account`s settings.
                  </div>

                    <div className="section">UI Method</div>
                    {this.radio('is_snap_pop_up', true, 'Pop Up')}
                    {this.radio('is_snap_pop_up', false, 'Redirection')}

                  <div>

                    <div className="section">Active Payment Channels</div>
                    {this.radio('enabled_payments_use', false, 'All', () => {
                      this.changeSettings('enabled_payments_use', false)
                    })}
                    <div
                      className={classnames('radio-group inline-block with-subsection', {active: this.state.chargeSettings['enabled_payments_use']})}>
                      <input type="radio"
                             name={name} id="customselect"
                             onChange={() => {
                               this.changeSettings('enabled_payments_use', true)
                             }}
                             value="optional"
                             checked={this.state.chargeSettings['enabled_payments_use']}/>
                      <label htmlFor="customselect">Custom Select</label>
                    </div>
                    <div className={classnames('subsection', {active: this.state.chargeSettings.enabled_payments_use})}>
                      {this.checkbox('enabled_payments', 'credit_card', 'Credit Card')}
                      {this.checkbox('enabled_payments', 'bank_transfer', 'Virtual Account / Bank Transfer')}
                      {this.checkbox('enabled_payments', 'gopay', 'GoPay')}
                      {this.checkbox('enabled_payments', 'shopeepay', 'ShopeePay')}
                      {this.checkbox('enabled_payments', 'dana', 'Dana')}
                      {this.checkbox('enabled_payments', 'indomaret', 'Indomaret')}
                      {this.checkbox('enabled_payments', 'alfamart', 'Alfamart')}
                      {this.checkbox('enabled_payments', 'akulaku', 'Akulaku')}
                      {this.checkbox('enabled_payments', 'kredivo', 'Kredivo')}
                      {this.checkbox('enabled_payments', 'google_pay', 'GooglePay')}
                      {this.checkbox('enabled_payments', 'other_qris', 'Other QRIS')}
                    </div>
                    {this.gopayTokenizationPayment()}
                    {this.creditCardPayment()}
                  </div>
                  <div>
                    {this.atmTransferPayment()}
                    <div className="section">Merchant Settings</div>
                    <div className="row">
                      <div className="col-sm-12">
                        <label className="section-label">Sandbox Keys</label>
                      </div>
                      <div className="col-sm-12">
                        <div className="radio-group inline-block">
                          <input type="radio" name="use_merchant_keys" id="use_merchant_keys:disabled" onChange={() => {
                            this.changeSettings('use_merchant_keys', false)
                          }} checked={!this.state.chargeSettings['use_merchant_keys']}></input>
                          <label htmlFor="use_merchant_keys:disabled">Disabled</label>
                        </div>
                        <div
                          className={classnames('radio-group inline-block with-subsection', {active: this.state.chargeSettings['use_merchant_keys']})}>
                          <input type="radio" name="use_merchant_keys" id="use_merchant_keys:enabled" onChange={() => {
                            this.changeSettings('use_merchant_keys', true)
                          }} checked={this.state.chargeSettings['use_merchant_keys']}></input>
                          <label htmlFor="use_merchant_keys:enabled">Enabled</label>
                        </div>
                        <div
                          className={classnames('subsection', {active: this.state.chargeSettings['use_merchant_keys']})}>
                          <div>
                            <br/>
                            <div className="alert danger">Only input your <strong>SANDBOX</strong> Server-Key and
                              Client-Key. <a className="btn"
                                             href="https://dashboard.sandbox.midtrans.com/settings/config_info"
                                             target="_blank">Access Keys
                                <small>↗</small>
                              </a></div>
                            <br/>
                            <input type="text" placeholder="Sandbox Server Key" ref="server_key"
                                   onChange={() => this.changeSettings('server_key', this.refs.server_key.value)}
                                   value={this.state.chargeSettings.server_key}/>
                            <input type="text" placeholder="Sandbox Client Key" ref="client_key"
                                   onChange={() => this.changeSettings('client_key', this.refs.client_key.value)}
                                   value={this.state.chargeSettings.client_key}/>
                            <br/>
                            <div className="alert success">Try changing Snap's settings in your MAP Dashboard and see it
                              live here. <a className="btn"
                                            href="https://dashboard.sandbox.midtrans.com/settings/snap_preference"
                                            target="_blank">Snap Preferences
                                <small>↗</small>
                              </a></div>
                            <br/>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                  <br/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <div className="pull-left hide-sm">
            <a href="#" className="btn btn-transparent" onClick={this.onCancel}>Cancel</a>
          </div>
          <div className="pull-right">
            <div className="checkbox-group inline-block">
              <input type="checkbox" name="snapSettings" id="saveSetting" value="saveSetting"
                     onChange={this.onSaveSettings}></input>
              <label htmlFor="saveSetting">Save settings</label>
            </div>
            <a href="#" className="btn btn-primary" onClick={this.onStart}>Start</a>
          </div>
        </div>
      </div>
    )
  }
}

export default Settings



// WEBPACK FOOTER //
// ./src/js/components/settings.jsx